module.exports = __webpack_public_path__ + "static/media/passInactive.svg";